import React from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  Button,
  IconButton,
  Section,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Grid,
  Stack,
  Picker,
  CloseIcon,
  RemoveCircleOutlineIcon,
} from '@gogame/components';
import { FormField, FormFieldArray, FormErrorMessage } from '@gogame/form';
import { useQuery } from '@gogame/query';

import { loadAgencies } from 'scenes/Influencers/InfluencersChannels/sources/fields';

import { PRICE, PRICE_WITH_FEE, AGENCY, AGENCIES } from './constants';

const Agencies = () => {
  const { data: agencies, isFetching } = useQuery('agencies', loadAgencies);

  return (
    <FormFieldArray name={AGENCIES}>
      {({ push, remove, form }) => {
        const value = form.values[AGENCIES];
        const valueIds = value?.map((v) => v.id);
        const selectableAgencies = agencies?.filter(
          (a) => !valueIds?.includes(a.id)
        );
        const error = form.errors?.[AGENCIES];

        return (
          <Section title={'Agencies *'}>
            <Stack
              spacing={2}
              {...(error ? { 'data-cy-has-error': true } : null)}
            >
              <Grid item>
                <Picker
                  button={<Button add>Agency</Button>}
                  onChange={([agency]) => {
                    push({ [AGENCY]: agency.id });
                  }}
                  loading={isFetching}
                  options={selectableAgencies}
                />
              </Grid>
              {!isEmpty(value) ? (
                <Grid item xs={12}>
                  <TableContainer>
                    <Table size={'small'}>
                      <TableHead>
                        <TableRow>
                          <TableCell size={'medium'}>Name</TableCell>
                          <TableCell size={'medium'} width={136}>
                            Price *
                          </TableCell>
                          <TableCell size={'medium'} width={136}>
                            Price with fees *
                          </TableCell>
                          <TableCell
                            size={'medium'}
                            align={'right'}
                            width={40}
                            padding={'actions'}
                          >
                            <IconButton
                              icon={<CloseIcon />}
                              tooltip={'Remove all'}
                              onClick={() =>
                                form.setFieldValue(AGENCIES, undefined)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {value.map((_agency, i) => (
                          <TableRow
                            key={`agency_${i}`}
                            style={{ verticalAlign: 'baseline' }}
                          >
                            <TableCell>
                              <FormField.Const
                                name={`${AGENCIES}[${i}]${AGENCY}`}
                                options={agencies}
                                padding={'0'}
                              />
                            </TableCell>
                            <TableCell>
                              <FormField.TextField
                                type={'currency'}
                                label={'Price'}
                                name={`${AGENCIES}[${i}]${PRICE}`}
                                placeholder={'$0'}
                                padding={'0'}
                              />
                            </TableCell>
                            <TableCell>
                              <FormField.TextField
                                type={'currency'}
                                label={'Price with fees'}
                                name={`${AGENCIES}[${i}]${PRICE_WITH_FEE}`}
                                placeholder={'$0'}
                                padding={'0'}
                              />
                            </TableCell>
                            <TableCell align={'right'}>
                              <IconButton
                                icon={<RemoveCircleOutlineIcon />}
                                tooltip={'Remove'}
                                onClick={() => remove(i)}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              ) : null}
              <FormErrorMessage name={AGENCIES} />
            </Stack>
          </Section>
        );
      }}
    </FormFieldArray>
  );
};

export default Agencies;
